import { createBrowserRouter } from 'react-router-dom';

// routes
import AuthenticationRoutes from './AuthenticationRoutes';
import PreviewRoutes from './PreviewRoutes';

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter([AuthenticationRoutes, PreviewRoutes], {
    basename: process.env.REACT_APP_BASE_NAME
});
export default router;
